/// #if PLATFORM === 'xd'
<template>
  <form
    class="searchForm"
    @submit.prevent="onSearch"
  >
    <input
      ref="input"
      type="search"
      :value="query"
      :placeholder="$route.params.username ? $t('pages.home.designer_search_ph') : $t('pages.home.search_ph')"
    />
  </form>
</template>
/// #else
<template>
  <div>
    <input
      ref="input"
      type="search"
      class="form-control"
      :value="query"
      :placeholder="$route.params.username ? $t('pages.home.designer_search_ph') : $t('pages.home.search_ph')"
      @keydown.enter.prevent="onSearch"
    />

    <ModalItemProfile
      :uuid="uuid"
      :visible.sync="showItemDetailsModal"
    />
  </div>
</template>
/// #endif

<script>
import isUrl from 'is-url'
import parseURL from 'url-parse'

import request from '@/lib/axios'

/// #if PLATFORM !== 'xd'
import ModalItemProfile from '@/modals/item/Profile'
/// #endif

const COMMAND_CHANGE_BRANCH = 'icondrop-change-branch:'

export default {
  components: {
    // eslint-disable-next-line indent
/// #if PLATFORM !== 'xd'
    ModalItemProfile
    // eslint-disable-next-line indent
/// #endif
  },

  props: {
    asset: {
      type: String,
      default: 'icon'
    }
  },

  data () {
    return {
      uuid: null,
      showItemDetailsModal: false
    }
  },

  computed: {
    query () {
      return this.$route.params.slug
    },
    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    isWindows () {
      const platform = require('os').platform()
      return platform.match(/^win(.)*/) !== null || false
    }
    // eslint-disable-next-line
/// #endif
  },

  methods: {
    onKeyDown (e) {
      console.log(e.keyCode)
    },
    async onSearch () {
      const query = this.$refs.input.value

      if (query.indexOf(COMMAND_CHANGE_BRANCH) > -1) {
        // Change to specified branch in Icondrop
        const branch = query.replace(COMMAND_CHANGE_BRANCH, '')
        window.location.href = window.location.origin + '/' + branch + '/index.html'
      } else if (isUrl(query)) {
        // If that's url then go that that specific asset
        this.showItemDetailsModal = false

        const url = parseURL(query, true)
        if (url.pathname !== '') {
          const data = url.pathname.split('/')

          let type = null
          let slug = null
          let asset = null

          switch (data[1]) {
            case 'icon':
              type = 'item'
              asset = 'icon'
              slug = data[2]
              break
            case 'icon-pack':
              type = 'pack'
              slug = data[2]
              break
            case 'icons':
              type = 'search'
              asset = 'icon'
              slug = data[2]
              break
            case 'illustration':
              type = 'item'
              asset = 'illustration'
              slug = data[2]
              break
            case 'illustration-pack':
              type = 'pack'
              slug = data[2]
              break
            case 'illustrations':
              type = 'search'
              asset = 'illustration'
              slug = data[2]
              break
            case 'photo':
              type = 'item'
              asset = 'photo'
              slug = data[2]
              break
            case 'photo-pack':
              type = 'pack'
              slug = data[2]
              break
            case 'photos':
              type = 'search'
              asset = 'photo'
              slug = data[2]
              break
          }

          // If Item Profile
          if (type === 'item') {
            // Fetch Item
            let result = await request({
              route: 'items',
              params: {
                slug: slug
              }
            })

            this.uuid = result.data.response.item.uuid
            this.showItemDetailsModal = true
          } else if (type === 'search') {
            this.$router.push({
              name: `${asset}s-slug`,
              params: {
                slug
              },
              query: url.query
            })

            this.localValue = url.query
          } else if (type === 'pack') {
            this.$router.push({
              name: 'pack-slug',
              params: {
                slug
              }
            })
          }
        }
      } else {
        // Else Search
        this.$router.push({
          name: `${this.asset}s-slug`,
          params: {
            slug: query
          },
          query: {
            ...this.$route.query,
            sort: 'relevant'
          }
        })
      }
    }
  }
}
</script>
